import { createContext } from "react";
import { ChatContextType, AgentState } from "./type";
import { Run } from "../../services/appsync/types";

const defaultAgentState: AgentState = {
  status: "idle",
  currentIteration: 0,
  maxIterations: 15,
  reasoning: "",
  streamedText: "",
  reasoningHistory: [],
  sqlQueries: [],
  docSearches: [],
  charts: [],
  toolCalls: [],
  genericTables: [],
};

const defaultValue: ChatContextType = {
  transportKind: "legacy",
  transportCapabilities: {
    history: true,
    queue: true,
    resume: false,
  },
  isConnected: false,
  isConnecting: false,
  messages: [],
  setMessages: () => {},
  sendMessage: () => {},
  connectChat: (run: Run | null, context: string) => {},
  startNewConversation: () => {},
  disconnectChat: () => {},
  isAwaitingResponse: false,
  chatSessionId: null,
  chatContext: null,
  platformConnectionError: null,
  platformConnectionErrorKind: null,
  agentState: defaultAgentState,
  // Chat history
  chatHistory: [],
  chatHistoryLoading: false,
  fetchChatHistory: () => {},
  loadChatFromHistory: () => {},
  platformConversationHistory: [],
  platformConversationHistoryLoading: false,
  platformConversationHistoryError: null,
  refreshPlatformConversationHistory: async () => false,
  resumePlatformConversation: async () => false,
  platformConversationHasEarlierMessages: false,
  platformEarlierMessagesLoading: false,
  platformEarlierMessagesError: null,
  loadEarlierPlatformConversationMessages: async () => false,
  stopCurrentResponse: () => {},
  queuedMessages: 0,
  queuedPrompts: [],
  queuedPromptItems: [],
  cancelQueuedPrompt: () => {},
  queuedDispatchPaused: false,
  queuedDispatchPauseMessage: null,
  queuedDispatchCanRetry: false,
  retryQueuedDispatch: () => {},
  isStopRequested: false,
};

export const ChatContext = createContext(defaultValue);
